import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-000jurassic_horizalign_left",
  "use": "icon-000jurassic_horizalign_left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-000jurassic_horizalign_left\"><path d=\"M64 64h64v896H64z\" fill=\"#727272\" /><path d=\"M192 192h515v256H192z\" fill=\"#B3B3B3\" /><path d=\"M192 576h768v256H192z\" fill=\"#497CAD\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol